<template>
    <main id="content" class="relative w-full pt-20 xl:pt-28 2.5xl:pt-38">
        <section
            class="relative z-20 flex flex-col items-center w-full h-auto pt-12 pb-16 sm:py-16 lg:py-20 xl:py-12 2xl:py-20"
        >
            <div
                class="max-w-[calc(100%-3rem)] sm:px-4 md:px-0 sm:max-w-1.5xl xl:max-w-6.5xl 1.5xl:max-w-7xl 2xl:max-w-7xl mx-auto w-full"
            >

                <h1 class="text-white text-[40px] sm:text-[45px] md:text-[50px] lg:text-[54px] xl:text-[60px] 2xl:text-[64px] 3xl:text-[67px] 3.5xl:text-[70px] !leading-snug font-light tracking-[0.01em] mx-auto text-center mb-14 md:mb-16 lg:mb-18 xl:mb-20 2xl:mb-22 3xl:mb-24">
                    {{ $root.translateString("manual") }}
                </h1>

                <div
                    class="w-full flex flex-col xl:flex-row space-y-24 sm:space-y-30 xl:space-y-0 xl:space-x-12 2xl:space-x-15 2.5xl:space-x-20"
                >
                    <!-- <div class="pb-4 mb-2" v-if="!isLogged">
                        <div class="mt-0 checkout-container-row-2__title checkout-title">
                            <h4 class="checkout-title__left">01.</h4>
                            <h6 class="checkout-title__right text-uppercase">{{$root.translateString('personal_details')}}</h6>
                        </div>
                        <div class="checkout-container-row-2__inputs">
                            <div class="cart-dati-1-inputs">

                                <div class="p-3 mb-3 small-banner d-flex align-items-center">
                                    <a class="cover" href="javascript:void(0)" @click="summonPopup"></a>
                                    <img alt="login" class="mr-1" src="/images/area-utente/user-gold.svg" width="25"/>
                                    <p class="pl-2 mb-0 ml-1 torna-prodotti-link text-lightgrey text-smaller-85 d-inline-flex flex-grow-1">
                                        {{$root.translateString('have-an-account')}}
                                        <span class="ml-2 text-gold" href="javascript:void(0)" @click="toggleLogin">
                                    <span>{{$root.translateString('login-now')}}</span>
                                </span>
                                    </p>
                                    <span class="mr-1 arrow"><img width="32" src="/images/svg/roeno-17.svg" alt="dettagli"></span>
                                </div>

                                <div class="pt-3 double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                                    <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                        <input placeholder=" " type="text" @focus="validation.new_user.name.state = null" v-model="new_user.name">
                                        <div class="invalid-feedback" :class="{'d-block' : validation.new_user.name.state == false}">{{validation.new_user.name.message}}</div>
                                        <label class="full-input__after-input">
                                            {{$root.translateString('name')}}
                                        </label>
                                    </div>
                                    <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                        <div class="full-input__field-gr">
                                            <input placeholder=" " type="text" @focus="validation.new_user.email.state = null" v-model="new_user.email">
                                            <div class="invalid-feedback" :class="{'d-block' : validation.new_user.email.state == false}">{{validation.new_user.email.message}}</div>
                                            <label class="full-input__after-input">
                                                Email
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="pt-3 mt-4 checkout-container-row-2__checkbox">
                                    <div class="checkbox-styles">
                                        <div class="checkbox">
                                            <input type="checkbox" id="accept_privacy" @change="validation.new_user.privacy.state = null" v-model="new_user.privacy">
                                            <label class="d-inline-block w-100" for="accept_privacy"></label>
                                        </div>
                                        <label for="accept_privacy" class="mb-0 checkbox-styles__link">
                                            {{$root.translateString('acceptance')}} &nbsp;<a :href="'/' + lang + '/privacy-policy'">{{$root.translateString('acceptance_link')}}</a>
                                            <div class="pt-1 invalid-feedback" :class="{'d-block' : validation.new_user.privacy.state == false}">{{validation.new_user.privacy.message}}</div>
                                        </label>
                                    </div>
                                    <div class="mt-3 checkbox-styles">
                                        <div class="checkbox">
                                            <input id="create_account" type="checkbox" v-model="new_user.create_account">
                                            <label class="d-inline-block w-100" for="create_account"></label>
                                        </div>
                                        <label for="create_account" class="mb-0 checkbox-styles__link">
                                            {{$root.translateString('create-new-account')}}
                                        </label>
                                    </div>
                                </div>


                                <div class="pt-2 mt-4 double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row" v-if="new_user.create_account">
                                    <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                        <input placeholder=" " type="password" @focus="validation.new_user.password.state = null" v-model="new_user.password">
                                        <div class="invalid-feedback" :class="{'d-block' : validation.new_user.password.state == false}">{{validation.new_user.password.message}}</div>
                                        <label class="full-input__after-input">
                                            {{$root.translateString('password')}}
                                        </label>
                                    </div>
                                    <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                        <div class="full-input__field-gr">
                                            <input placeholder=" " type="password" @focus="validation.new_user.password_confirmation.state = null" v-model="new_user.password_confirmation">
                                            <div class="invalid-feedback" :class="{'d-block' : validation.new_user.password_confirmation.state == false}">{{validation.new_user.password_confirmation.message}}</div>
                                            <label class="full-input__after-input">
                                                {{$root.translateString('password_confirmation')}}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> -->

                    <div
                        class="relative flex-grow pt-5 space-y-26 xs:space-y-30"
                    >
                        <!-- ///////////////////// SPEDIZIONE -->

                        <div
                            v-if="orderData.should_be_shipped"
                            class="relative w-full"
                        >
                            <div
                                class="relative flex items-center w-full mb-12 space-x-4"
                            >
                                <span
                                    class="flex items-center justify-center w-10 h-10 p-3 text-base rounded-full bg-white/10 text-primary-300"
                                >
                                    <span v-if="!isLogged">2</span>
                                    <span v-else>1</span>
                                </span>
                                <span
                                    class="text-white text-1.5xl xs:text-2xl tracking-[0.05em] uppercase text-center"
                                >
                                    {{
                                        $root.translateString(
                                            "shipping_details"
                                        )
                                    }}
                                </span>
                            </div>

                            <div>
                                <div
                                    class="relative w-full grid grid-cols-1 xl:grid-cols-2 gap-y-8 sm:gap-y-12 2xl:gap-y-14 2.5xl:gap-y-16 xl:gap-x-12"
                                >
                                    <!-- <div class="checkout-container-row-2__title checkout-title" :class="{'pt-0 mt-2' : isLogged, 'mt-0 pt-0' : !isLogged}">
                                        <h4 class="checkout-title__left">
                                            <span v-if="!isLogged">02.</span>
                                            <span v-else>01.</span>
                                        </h4>
                                        <h6 class="checkout-title__right text-uppercase">{{$root.translateString('shipping_details')}}</h6>
                                    </div> -->

                                    <span
                                        class="relative block w-full col-span-2"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.address.name.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="
                                                    orderData.data.ship.name
                                                "
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "name"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.address.name.state !=
                                                null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.address.name.message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.address.phone.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="tel"
                                                v-model="
                                                    orderData.data.ship.phone
                                                "
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "phone"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.address.phone
                                                    .state != null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.address.phone.message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        class="relative block w-full col-span-2 pointer-events-none xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <v-select
                                                @input="
                                                    validation.address.country.state =
                                                        null
                                                "
                                                v-model="
                                                    orderData.data.ship.country
                                                "
                                                :class="{
                                                    full:
                                                        address.country !=
                                                            null &&
                                                        address.country != '',
                                                }"
                                                :options="countries"
                                                label="value"
                                                index="label"
                                                :reduce="(label) => label.label"
                                                class="pointer-events-none"
                                            >
                                                <template
                                                    v-slot:no-options="{
                                                        search,
                                                        searching,
                                                    }"
                                                >
                                                    <template v-if="searching">
                                                        <small class="not-found"
                                                            >{{
                                                                $root.translateString(
                                                                    "no_results"
                                                                )
                                                            }}
                                                            <strong>{{
                                                                search
                                                            }}</strong></small
                                                        >
                                                    </template>
                                                </template>
                                            </v-select>

                                            <label
                                                class="whitespace-nowrap text-white text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] xl:text-[28px] 2xl:text-[30px] absolute left-1/2 -translate-x-1/2 top-0 !tracking-[0.01em] font-light !leading-4 opacity-50 pointer-events-none transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "country"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.address.country
                                                    .state != null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.address.country
                                                    .message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.address.address.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="
                                                    orderData.data.ship.address
                                                "
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "address"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.address.address
                                                    .state != null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.address.address
                                                    .message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.address.city.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="text"
                                                v-model="
                                                    orderData.data.ship.city
                                                "
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "city"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.address.city.state !=
                                                null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.address.city.message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        v-if="
                                            orderData.data.ship.country.toLowerCase() ==
                                                'it' ||
                                            address.country.toLowerCase() == ''
                                        "
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <v-select
                                                @input="
                                                    validation.address.province.state =
                                                        null
                                                "
                                                v-model="
                                                    orderData.data.ship.province
                                                "
                                                :options="provinces"
                                                label="value"
                                                index="label"
                                                :reduce="(label) => label.label"
                                                @search:focus="
                                                    provinceFocusAddress = true
                                                "
                                                @search:blur="
                                                    provinceFocusAddress = false
                                                "
                                            >
                                                <template
                                                    v-slot:no-options="{
                                                        search,
                                                        searching,
                                                    }"
                                                >
                                                    <template v-if="searching">
                                                        <small class="not-found"
                                                            >{{
                                                                $root.translateString(
                                                                    "no_results"
                                                                )
                                                            }}
                                                            <strong>{{
                                                                search
                                                            }}</strong></small
                                                        >
                                                    </template>
                                                </template>
                                            </v-select>

                                            <label
                                                class="whitespace-nowrap text-white text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] xl:text-[28px] 2xl:text-[30px] absolute left-1/2 -translate-x-1/2 top-0 !tracking-[0.01em] font-light !leading-4 opacity-50 pointer-events-none transition-all"
                                                :class="
                                                    ((orderData.data.ship
                                                        .province != null &&
                                                        orderData.data.ship
                                                            .province != '') ||
                                                        provinceFocusAddress) &&
                                                    '!text-xs !-top-4'
                                                "
                                            >
                                                {{
                                                    $root.translateString(
                                                        "province"
                                                    )
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.address.province
                                                    .state != null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{
                                                validation.address.province
                                                    .message
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        class="relative block w-full col-span-2 xl:col-span-1"
                                    >
                                        <span
                                            class="relative flex flex-col w-full text-white"
                                        >
                                            <input
                                                data-lpignore="true"
                                                @focus="
                                                    validation.address.cap.state =
                                                        null
                                                "
                                                class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                                placeholder=" "
                                                type="number"
                                                v-model="
                                                    orderData.data.ship.cap
                                                "
                                            />
                                            <label
                                                class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                            >
                                                {{
                                                    $root.translateString("cap")
                                                }}
                                            </label>
                                        </span>
                                        <span
                                            v-if="
                                                validation.address.cap.state !=
                                                null
                                            "
                                            class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                        >
                                            {{ validation.address.cap.message }}
                                        </span>
                                    </span>

                                    <!-- <span class="flex flex-col items-center justify-center w-full space-y-10 sm:flex-row sm:space-y-0">
                                        <span class="flex-grow">
                                            <span class="flex items-center space-x-3">
                                                <span class="w-[30px] h-[30px] relative block">
                                                    <input name="require-invoice" id="require-invoice" class="absolute top-0 left-0 w-full h-full outline-none opacity-0 accent-transparent ring-0" type="checkbox" v-model="user.billing.require_invoice">
                                                    <span class="absolute top-0 left-0 w-full h-full bg-center bg-no-repeat border pointer-events-none fake-checkbox border-white/50"></span>
                                                </span>
                                                <label for="require-invoice" class="cursor-pointer">
                                                    <span class="text-lg text-white/50 lg:text-xl">{{$root.translateString('ask_for_invoice')}}</span>
                                                </label>
                                            </span>
                                        </span>
                                    </span> -->
                                </div>
                            </div>
                        </div>

                        <!-- ////////////////////// FATTURAZIONE -->

                        <div
                            v-if="user.billing.require_invoice"
                            class="relative w-full"
                        >
                            <div
                                class="relative flex items-center w-full mb-12 space-x-4"
                            >
                                <span
                                    class="flex items-center justify-center w-10 h-10 p-3 text-base rounded-full bg-white/10 text-primary-300"
                                >
                                    <span v-if="!isLogged">3</span>
                                    <span v-else>2</span>
                                </span>
                                <span
                                    class="text-white text-1.5xl xs:text-2xl tracking-[0.05em] uppercase text-center"
                                >
                                    {{
                                        $root.translateString("invoice_details")
                                    }}
                                </span>
                            </div>

                            <div
                                class="w-[330px] h-auto relative grid grid-cols-2 mt-12 mb-12 gap-x-4"
                            >
                                <button
                                    type="button"
                                    @click="
                                        orderData.data.billing.type = 'private'
                                    "
                                    :class="
                                        orderData.data.billing.type == 'private'
                                            ? 'bg-white/10 py-1.5 rounded-full flex items-center justify-center pointer-events-none px-8'
                                            : 'bg-transparent py-1.5 rounded-full flex items-center justify-center hover:bg-white/10 transition-all px-8'
                                    "
                                >
                                    <span
                                        class="text-primary-300 text-[18px] md:text-[19px] xl:text-[20px] relative left-0.5"
                                    >
                                        {{ $root.translateString("private") }}
                                    </span>
                                </button>
                                <button
                                    type="button"
                                    @click="
                                        orderData.data.billing.type = 'company'
                                    "
                                    :class="
                                        orderData.data.billing.type == 'company'
                                            ? 'bg-white/10 py-1.5 rounded-full flex items-center justify-center pointer-events-none px-8'
                                            : 'bg-transparent py-1.5 rounded-full flex items-center justify-center hover:bg-white/10 transition-all px-8'
                                    "
                                >
                                    <span
                                        class="text-primary-300 text-[18px] md:text-[19px] xl:text-[20px] relative left-0.5"
                                    >
                                        {{ $root.translateString("company") }}
                                    </span>
                                </button>
                            </div>

                            <div
                                class="relative w-full grid grid-cols-2 gap-y-8 sm:gap-y-12 2xl:gap-y-14 2.5xl:gap-y-16 lg:gap-x-12"
                            >
                                <span
                                    v-if="
                                        orderData.data.billing.type == 'company'
                                    "
                                    class="relative block w-full col-span-2 xl:col-span-1"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <input
                                            data-lpignore="true"
                                            @focus="
                                                validation.billing.name.state =
                                                    null
                                            "
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                            placeholder=" "
                                            type="text"
                                            v-model="
                                                orderData.data.billing.name
                                            "
                                        />
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{
                                                $root.translateString(
                                                    "company_name"
                                                )
                                            }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.name.state !=
                                            null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{ validation.billing.name.message }}
                                    </span>
                                </span>

                                <span
                                    v-if="
                                        orderData.data.billing.type == 'company'
                                    "
                                    class="relative block w-full col-span-2 xl:col-span-1"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <input
                                            data-lpignore="true"
                                            @focus="
                                                validation.billing.fiscal_code.state =
                                                    null
                                            "
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer uppercase"
                                            placeholder=" "
                                            type="text"
                                            v-model="
                                                orderData.data.billing
                                                    .fiscal_code
                                            "
                                        />
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{ $root.translateString("vat") }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.fiscal_code
                                                .state != null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{
                                            validation.billing.fiscal_code
                                                .message
                                        }}
                                    </span>
                                </span>

                                <span
                                    v-if="
                                        orderData.data.billing.type == 'company'
                                    "
                                    class="relative block w-full col-span-2 xl:col-span-1"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <input
                                            data-lpignore="true"
                                            @focus="
                                                validation.billing.pec.state =
                                                    null
                                            "
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                            placeholder=" "
                                            type="email"
                                            v-model="orderData.data.billing.pec"
                                        />
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{ $root.translateString("pec") }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.pec.state != null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{ validation.billing.pec.message }}
                                    </span>
                                </span>

                                <span
                                    v-if="
                                        orderData.data.billing.type == 'company'
                                    "
                                    class="relative block w-full col-span-2 xl:col-span-1"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <input
                                            data-lpignore="true"
                                            @focus="
                                                validation.billing.sdi.state =
                                                    null
                                            "
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                            placeholder=" "
                                            type="text"
                                            v-model="orderData.data.billing.sdi"
                                        />
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{ $root.translateString("sdi") }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.sdi.state != null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{ validation.billing.sdi.message }}
                                    </span>
                                </span>

                                <span
                                    v-if="
                                        orderData.data.billing.type == 'company'
                                    "
                                    class="relative block w-full col-span-2 xl:col-span-1"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <input
                                            data-lpignore="true"
                                            @focus="
                                                validation.billing.address.state =
                                                    null
                                            "
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                            placeholder=" "
                                            type="text"
                                            v-model="
                                                orderData.data.billing.address
                                            "
                                        />
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{
                                                $root.translateString("address")
                                            }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.address.state !=
                                            null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{ validation.billing.address.message }}
                                    </span>
                                </span>

                                <span
                                    v-if="
                                        orderData.data.billing.type == 'company'
                                    "
                                    class="relative block w-full col-span-2 xl:col-span-1"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <input
                                            data-lpignore="true"
                                            @focus="
                                                validation.billing.city.state =
                                                    null
                                            "
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                            placeholder=" "
                                            type="text"
                                            v-model="
                                                orderData.data.billing.city
                                            "
                                        />
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{ $root.translateString("city") }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.city.state !=
                                            null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{ validation.billing.city.message }}
                                    </span>
                                </span>

                                <span
                                    v-if="
                                        orderData.data.billing.type == 'company'
                                    "
                                    class="relative block w-full col-span-2 xl:col-span-1"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <v-select
                                            @input="
                                                validation.billing.province.state =
                                                    null
                                            "
                                            v-model="
                                                orderData.data.billing.province
                                            "
                                            :options="provinces"
                                            label="value"
                                            index="label"
                                            :reduce="(label) => label.label"
                                            @search:focus="
                                                provinceFocusBilling = true
                                            "
                                            @search:blur="
                                                provinceFocusBilling = false
                                            "
                                        >
                                            <template
                                                v-slot:no-options="{
                                                    search,
                                                    searching,
                                                }"
                                            >
                                                <template v-if="searching">
                                                    <small class="not-found"
                                                        >{{
                                                            $root.translateString(
                                                                "no_results"
                                                            )
                                                        }}
                                                        <strong>{{
                                                            search
                                                        }}</strong></small
                                                    >
                                                </template>
                                            </template>
                                        </v-select>

                                        <label
                                            class="whitespace-nowrap text-white text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] xl:text-[28px] 2xl:text-[30px] absolute left-1/2 -translate-x-1/2 top-0 !tracking-[0.01em] font-light !leading-4 opacity-50 pointer-events-none transition-all"
                                            :class="
                                                ((billing.province != null &&
                                                    billing.province != '') ||
                                                    provinceFocusBilling) &&
                                                '!text-xs !-top-4'
                                            "
                                        >
                                            {{
                                                $root.translateString(
                                                    "province"
                                                )
                                            }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.province.state !=
                                            null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{
                                            validation.billing.province.message
                                        }}
                                    </span>
                                </span>

                                <span
                                    v-if="
                                        orderData.data.billing.type == 'company'
                                    "
                                    class="relative block w-full col-span-2 xl:col-span-1"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <input
                                            data-lpignore="true"
                                            @focus="
                                                validation.billing.cap.state =
                                                    null
                                            "
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                            placeholder=" "
                                            type="text"
                                            v-model="orderData.data.billing.cap"
                                        />
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{ $root.translateString("cap") }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.cap.state != null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{ validation.billing.cap.message }}
                                    </span>
                                </span>

                                <span
                                    v-if="
                                        orderData.data.billing.type == 'private'
                                    "
                                    class="relative block w-full col-span-2"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <input
                                            data-lpignore="true"
                                            @focus="
                                                validation.billing.fiscal_code.state =
                                                    null
                                            "
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                            placeholder=" "
                                            type="text"
                                            v-model="
                                                orderData.data.billing
                                                    .fiscal_code
                                            "
                                        />
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{
                                                $root.translateString(
                                                    "fiscal_code"
                                                )
                                            }}
                                        </label>
                                    </span>
                                    <span
                                        v-if="
                                            validation.billing.fiscal_code
                                                .state != null
                                        "
                                        class="invalid text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2"
                                    >
                                        {{
                                            validation.billing.fiscal_code
                                                .message
                                        }}
                                    </span>
                                </span>

                                <!-- <div class="mt-2 checkout-container-row-2__checkbox mt-lg-5" v-if="!hide_save_billing_info || new_user.create_account">
                                    <div class="checkbox-styles">
                                        <div class="checkbox">
                                            <input data-lpignore="true" type="checkbox" id="save_billing_info" class="cb" name="save_billing_info" v-model="save_billing_info">
                                            <label for="save_billing_info"></label>
                                        </div>
                                        <label for="save_billing_info" class="mb-0 checkbox-styles__link checkout">
                                            <span>{{$root.translateString('update-billing-data')}}</span>
                                        </label>
                                    </div>
                                </div> -->
                            </div>
                        </div>

                        <!-- ////////////////////// PAGAMENTO -->

                        <div class="relative w-full">
                            <div
                                class="relative flex items-center w-full mb-6 space-x-4 md:mb-12"
                            >
                                <span
                                    class="flex items-center justify-center w-10 h-10 p-3 text-base rounded-full bg-white/10 text-primary-300"
                                >
                                    <template v-if="address.country == 'IT'">
                                        <span v-if="!isLogged">4</span>
                                        <span v-else>3</span>
                                    </template>
                                    <template v-else>
                                        <span>2</span>
                                    </template>
                                </span>
                                <span
                                    class="text-white text-1.5xl xs:text-2xl tracking-[0.05em] uppercase text-center"
                                >
                                    <span class="xs:hidden">{{
                                        $root.translateString(
                                            "payment_methods_short"
                                        )
                                    }}</span>
                                    <span class="hidden xs:inline">{{
                                        $root.translateString("payment_methods")
                                    }}</span>
                                </span>
                            </div>

                            <div class="relative flex flex-col w-full">
                                <button
                                    type="button"
                                    @click="orderData.payment_method = 'stripe'"
                                    class="flex flex-col py-6 space-x-3 border-b cursor-pointer xs:flex-row xs:items-center border-white/50"
                                >
                                    <span
                                        class="flex items-center flex-grow space-x-2 xs:space-x-3"
                                    >
                                        <span
                                            class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-primary-400"
                                        >
                                            <span
                                                v-if="
                                                    orderData.payment_method ==
                                                    'stripe'
                                                "
                                                class="block w-2 h-2 rounded-full bg-primary-400"
                                            ></span>
                                        </span>
                                        <span
                                            class="flex flex-col items-start flex-grow pl-2"
                                        >
                                            <span
                                                class="text-white text-lg xs:text-xl tracking-[3px] uppercase"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "credit_card"
                                                    )
                                                }}
                                            </span>
                                            <span
                                                class="flex !leading-none text-left items-center text-secondary-400 pt-1 xs:pt-0 text-lg"
                                                v-if="
                                                    orderData.payment_method ==
                                                    'stripe'
                                                "
                                            >
                                                {{
                                                    $root.translateString(
                                                        "credit_card_p"
                                                    )
                                                }}
                                            </span>
                                        </span>
                                    </span>
                                    <span
                                        class="flex items-center h-full pt-3 pl-6 xs:pt-0 xs:pl-0"
                                    >
                                        <img
                                            class="w-auto h-7"
                                            src="/images/svg/credit-card.svg"
                                            alt="Carta di credito"
                                            height="25"
                                        />
                                    </span>
                                </button>

                                <button
                                    type="button"
                                    @click="orderData.payment_method = 'bank'"
                                    class="flex flex-col py-6 space-x-3 border-b cursor-pointer xs:flex-row xs:items-center border-white/50"
                                >
                                    <span
                                        class="flex items-center flex-grow space-x-2 xs:space-x-3"
                                    >
                                        <span
                                            class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-primary-400"
                                        >
                                            <span
                                                v-if="
                                                    orderData.payment_method ==
                                                    'bank'
                                                "
                                                class="block w-2 h-2 rounded-full bg-primary-400"
                                            ></span>
                                        </span>
                                        <span
                                            class="flex flex-col items-start flex-grow pl-2"
                                        >
                                            <span
                                                class="text-white text-lg xs:text-xl tracking-[3px] uppercase"
                                            >
                                                {{
                                                    $root.translateString(
                                                        "wire_transfer"
                                                    )
                                                }}
                                            </span>
                                            <span
                                                class="flex !leading-none text-left items-center text-secondary-400 pt-1 xs:pt-0 text-lg"
                                                v-if="
                                                    orderData.payment_method ==
                                                    'bank'
                                                "
                                            >
                                                {{
                                                    $root.translateString(
                                                        "wire_transfer_p"
                                                    )
                                                }}
                                            </span>
                                        </span>
                                    </span>
                                    <span
                                        class="flex items-center h-full pt-3 pl-6 xs:pt-0 xs:pl-0"
                                    >
                                        <img
                                            class="w-auto h-7"
                                            src="/images/svg/bankwire.svg"
                                            alt="Bonifico bancario"
                                            height="25"
                                        />
                                    </span>
                                </button>

                                <button
                                    type="button"
                                    @click="orderData.payment_method = 'paypal'"
                                    class="flex flex-col py-6 space-x-3 border-b cursor-pointer xs:flex-row xs:items-center border-white/50"
                                >
                                    <span
                                        class="flex items-center flex-grow space-x-2 xs:space-x-3"
                                    >
                                        <span
                                            class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-primary-400"
                                        >
                                            <span
                                                v-if="
                                                    orderData.payment_method ==
                                                    'paypal'
                                                "
                                                class="block w-2 h-2 rounded-full bg-primary-400"
                                            ></span>
                                        </span>
                                        <span
                                            class="flex flex-col items-start flex-grow pl-2"
                                        >
                                            <span
                                                class="text-white text-lg xs:text-xl tracking-[3px] uppercase"
                                            >
                                                Paypal
                                            </span>
                                            <span
                                                class="flex !leading-none text-left items-center text-secondary-400 pt-1 xs:pt-0 text-lg"
                                                v-if="
                                                    orderData.payment_method ==
                                                    'paypal'
                                                "
                                            >
                                                {{
                                                    $root.translateString(
                                                        "paypal_p"
                                                    )
                                                }}
                                            </span>
                                        </span>
                                    </span>
                                    <span
                                        class="flex items-center h-full pt-3 pl-6 xs:pt-0 xs:pl-0"
                                    >
                                        <img
                                            class="w-auto h-7"
                                            src="/images/svg/paypal.svg"
                                            alt="Paypal"
                                            height="25"
                                        />
                                    </span>
                                </button>

                                <button
                                    type="button"
                                    @click="
                                        orderData.payment_method = 'applePay'
                                    "
                                    class="flex flex-col py-6 space-x-3 border-b cursor-pointer xs:flex-row xs:items-center border-white/50"
                                    v-if="paymentRequest != null"
                                >
                                    <span
                                        class="flex items-center flex-grow space-x-2 xs:space-x-3"
                                    >
                                        <span
                                            class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-primary-400"
                                        >
                                            <span
                                                v-if="
                                                    orderData.payment_method ==
                                                    'applePay'
                                                "
                                                class="block w-2 h-2 rounded-full bg-primary-400"
                                            ></span>
                                        </span>
                                        <span
                                            class="flex flex-col items-start flex-grow pl-2"
                                        >
                                            <span
                                                class="text-white text-lg xs:text-xl tracking-[3px] uppercase"
                                            >
                                                Apple Pay / Google Pay
                                            </span>
                                            <span
                                                class="flex !leading-none text-left items-center text-secondary-400 pt-1 xs:pt-0 text-lg"
                                                v-if="
                                                    orderData.payment_method ==
                                                    'applePay'
                                                "
                                            >
                                                {{
                                                    $root.translateString(
                                                        "apple_pay_p"
                                                    )
                                                }}
                                            </span>
                                        </span>
                                    </span>
                                    <span
                                        class="flex items-center h-full pt-3 pl-6 xs:pt-0 xs:pl-0"
                                    >
                                        <img
                                            class="w-auto h-7"
                                            src="/images/svg/apple-google-pay.svg"
                                            alt="Apple Pay - Google Pay"
                                            height="25"
                                        />
                                    </span>
                                </button>
                            </div>
                        </div>

                        <!-- ////////////////////// MESSAGGIO -->

                        <div class="relative w-full">
                            <div
                                class="relative flex items-center w-full mb-12 space-x-4"
                            >
                                <span
                                    class="flex items-center justify-center w-10 h-10 p-3 text-base rounded-full bg-white/10 text-primary-300"
                                >
                                    <template v-if="address.country == 'IT'">
                                        <span v-if="!isLogged">5</span>
                                        <span v-else>4</span>
                                    </template>
                                    <template v-else>
                                        <span>3</span>
                                    </template>
                                </span>
                                <span
                                    class="text-white text-1.5xl xs:text-2xl tracking-[0.05em] uppercase text-center"
                                >
                                    {{ $root.translateString("ask_for_gift") }}
                                </span>
                            </div>

                            <div class="relative flex flex-col w-full">
                                <span
                                    v-if="giftPack.status"
                                    class="relative block w-full"
                                >
                                    <span
                                        class="relative flex flex-col w-full text-white"
                                    >
                                        <textarea
                                            rows="3"
                                            class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[141px] text-white text-1.5xl 2xl:text-2xl text-center peer"
                                            placeholder=" "
                                            v-model="giftPack.message"
                                        ></textarea>
                                        <label
                                            class="whitespace-nowrap text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all"
                                        >
                                            {{
                                                $root.translateString(
                                                    "giftpack_title"
                                                )
                                            }}
                                        </label>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- -->

                    <div
                        class="flex flex-col w-full space-y-8 xl:w-[460px] xl:sticky xl:top-[110px] 2.5xl:top-[130px] self-start"
                    >
                        <div
                            class="p-6 sm:p-10 xl:p-12 xl:w-auto w-full text-lg sm:text-xl xl:text-xl 2.5xl:text-1.5xl text-secondary-400 bg-white/5"
                        >
                            <!-- <h4 class="text-white text-lg tracking-[3px] uppercase text-center mb-6 xl:-mt-2">
                                {{$root.translateString('summary')}}
                            </h4> -->

                            <div
                                class="relative flex flex-col w-full pb-6 mb-6 space-y-6 border-b border-secondary-400/20"
                            >
                                <div
                                    class="flex items-start w-full"
                                    v-for="(item, key) in orderData.products"
                                    :key="key"
                                >
                                    <div
                                        class="flex items-center justify-center w-16 h-16 p-3 min-w-16 xs:w-20 xs:min-w-20 xs:h-20 md:w-22 md:min-w-22 md:h-22 bg-white/10"
                                    >
                                        <img
                                            width="70"
                                            class="object-contain w-full h-full"
                                            :src="item.images[0]"
                                            :alt="item.name"
                                        />
                                    </div>
                                    <div class="flex flex-col flex-grow pl-6">
                                        <div
                                            class="flex flex-grow w-full pt-0 pl-0"
                                        >
                                            <span
                                                class="pr-2 h-full whitespace-nowrap relative -top-1.5"
                                                >{{
                                                    item.pivot.quantity
                                                }}
                                                x</span
                                            >
                                            <span
                                                class="flex flex-col flex-grow"
                                            >
                                                <span
                                                    class="uppercase text-white !leading-tight text-lg"
                                                    v-text="item.name"
                                                ></span>
                                                <span
                                                    class="w-full flex flex-col text-lg !leading-snug -mt-0.5"
                                                >
                                                    <span
                                                        class="w-full"
                                                        v-if="
                                                            item.type == 'vini'
                                                        "
                                                    >
                                                        {{
                                                            getValueFromAttributes(
                                                                item.pivot
                                                                    .combination,
                                                                "formato",
                                                                "value_label"
                                                            ) +
                                                            " - " +
                                                            getValueFromAttributes(
                                                                item.pivot
                                                                    .combination,
                                                                "anno",
                                                                "value_label"
                                                            )
                                                        }}
                                                    </span>
                                                    <span
                                                        class="w-full"
                                                        v-else-if="
                                                            item.type ==
                                                            'visite'
                                                        "
                                                    >
                                                        {{
                                                            getValueFromAttributes(
                                                                item.pivot
                                                                    .combination,
                                                                "visit",
                                                                "adults"
                                                            ) +
                                                            parseInt(
                                                                getValueFromAttributes(
                                                                    item.pivot
                                                                        .combination,
                                                                    "visit",
                                                                    "kids"
                                                                )
                                                            )
                                                        }}
                                                        <span
                                                            v-if="
                                                                getValueFromAttributes(
                                                                    item.pivot
                                                                        .combination,
                                                                    'visit',
                                                                    'adults'
                                                                ) == 1
                                                            "
                                                            >{{
                                                                $root.translateString(
                                                                    "person"
                                                                )
                                                            }}</span
                                                        >
                                                        <span v-else>{{
                                                            $root.translateString(
                                                                "people"
                                                            )
                                                        }}</span>
                                                        <span
                                                            v-if="
                                                                item.options
                                                                    .combination
                                                            "
                                                        >
                                                            -
                                                            {{
                                                                getValueFromAttributes(
                                                                    item.pivot
                                                                        .combination,
                                                                    "formato",
                                                                    "value_label"
                                                                ) +
                                                                " - " +
                                                                getValueFromAttributes(
                                                                    item.pivot
                                                                        .combination,
                                                                    "anno",
                                                                    "value_label"
                                                                )
                                                            }}
                                                        </span>
                                                    </span>
                                                    <span class="w-full" v-else
                                                        >Cantina Letrari</span
                                                    >
                                                </span>
                                            </span>
                                        </div>
                                        <div
                                            class="flex items-center flex-grow py-0 pl-0 mt-2"
                                        >
                                            <span class="flex-grow text-base">
                                                €
                                                {{
                                                    $root.currencyDisplaySimple(
                                                        parseFloat(
                                                            JSON.parse(
                                                                item.pivot
                                                                    .combination
                                                            )["price"]
                                                        ) *
                                                            parseInt(
                                                                item.pivot
                                                                    .quantity
                                                            )
                                                    )
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="flex items-center justify-center w-full px-3 py-2 mb-4 text-center bg-primary-400/20 sm:px-6 sm:py-3"
                            >
                                <span
                                    class="text-[15px] uppercase text-white !tracking-[0.05em]"
                                    >{{
                                        $root.translateString("free_shipping")
                                    }}
                                    <span>€110</span></span
                                >
                            </div>

                            <div
                                class="pb-5 mb-3 text-center border-b text-primary-400 border-secondary-400/20"
                                v-if="missing_for_free_shipping > 0"
                            >
                                <span
                                    class="!leading-none block w-full text-center"
                                    v-if="lang == 'it'"
                                >
                                    Sei a €
                                    {{
                                        $root.currencyDisplaySimple(
                                            missing_for_free_shipping
                                        )
                                    }}
                                    dalla spedizione gratuita.
                                </span>
                                <span
                                    class="!leading-none block w-full text-center"
                                    v-else
                                >
                                    €
                                    {{
                                        $root.currencyDisplaySimple(
                                            missing_for_free_shipping
                                        )
                                    }}
                                    left for free shipping.
                                </span>
                            </div>

                            <div class="flex pb-2">
                                <div class="flex-grow">
                                    {{ $root.translateString("subtotal") }}
                                </div>
                                <div class="">
                                    €
                                    {{
                                        $root.currencyDisplaySimple(
                                            orderData.total_price +
                                                orderData.total_discount
                                        )
                                    }}
                                </div>
                            </div>

                            <div
                                class="flex pb-4 spedizione"
                                v-if="orderData.should_be_shipped"
                            >
                                <div class="flex-grow">
                                    {{ $root.translateString("shipping") }}
                                </div>
                                <div class="">
                                    <span v-if="orderData.shipment_price > 0">
                                        €
                                        {{
                                            $root.currencyDisplaySimple(
                                                order.shipment_price
                                            )
                                        }}
                                    </span>
                                    <span v-else>{{
                                        $root.translateString("free")
                                    }}</span>
                                </div>
                            </div>

                            <div
                                class="flex pb-4 spedizione"
                                v-if="orderData.duties_price > 0"
                            >
                                <div class="flex-grow">
                                    {{ $root.translateString("customs") }}
                                </div>
                                <div class="">
                                    €
                                    {{
                                        $root.currencyDisplaySimple(
                                            order.duties_price
                                        )
                                    }}
                                </div>
                            </div>

                            <div
                                class="flex pb-4 spedizione"
                                v-if="discount > 0"
                            >
                                <div class="flex-grow">
                                    {{ $root.translateString("discount") }}
                                </div>
                                <div class="">
                                    € -{{
                                        $root.currencyDisplaySimple(
                                            order.total_discount
                                        )
                                    }}
                                </div>
                            </div>

                            <div
                                class="flex py-3 border-t border-secondary-400/20"
                            >
                                <div class="flex flex-col flex-grow">
                                    <div class="text-white">
                                        {{ $root.translateString("total") }}
                                    </div>
                                    <small class="-mt-2">{{
                                        $root.translateString("tax_included")
                                    }}</small>
                                </div>
                                <div class="text-white">
                                    €
                                    {{
                                        $root.currencyDisplaySimple(
                                            order.final_price
                                        )
                                    }}
                                </div>
                            </div>

                            <div class="w-full pt-2 mt-1 text-center">
                                <div class="flex w-full">
                                    <button
                                        type="button"
                                        v-if="
                                            orderData.payment_method !=
                                            'applePay'
                                        "
                                        @click="updateOrderAndPay"
                                        :class="{ loading: loading }"
                                        :disabled="btn_disabled"
                                        class="relative inline-flex border default-btn border-primary-300 group flex-grow w-full text-center xl:max-w-[340px] 2xl:max-w-[386px] hover:bg-primary-400/10 transition-all"
                                    >
                                        <span class="block w-full pt-2.5 pb-3 px-15 text-primary-300 text-[18px] md:text-[19px] xl:text-[20px]">
                                            {{$root.translateString('complete_order')}}
                                        </span>
                                        <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:left-6 transition-all"></span>
                                        <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:right-6 transition-all"></span>
                                    </button>
                                    <button
                                        type="button"
                                        v-else
                                        @click="
                                            updateOrderAndPay,
                                                paymentRequest.show()
                                        "
                                        href="javascript:void(0)"
                                        :class="{ loading: loading }"
                                        :disabled="btn_disabled"
                                        class="relative inline-flex border default-btn border-primary-300 group flex-grow w-full text-center xl:max-w-[340px] 2xl:max-w-[386px] hover:bg-primary-400/10 transition-all"
                                    >
                                        <span class="block w-full pt-2.5 pb-3 px-15 text-primary-300 text-[18px] md:text-[19px] xl:text-[20px]">
                                            {{$root.translateString('complete_order')}}
                                        </span>
                                        <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:left-6 transition-all"></span>
                                        <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:right-6 transition-all"></span>
                                    </button>
                                </div>
                            </div>

                            <!-- ////////////////////// TERMINI-->

                            <div
                                class="relative w-full px-5 pt-4 border-t border-secondary-400/20 mt-7 2xl:-mb-2"
                            >
                                <span
                                    class="text-secondary-400 text-xs space-x-2 space-y-1.5 !leading-normal block text-center"
                                    v-html="$root.translateString('before-buy')"
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
export default {
    props: [
        "lang",
        "provinces",
        "countries",
        "order",
        "isLogged",
        "blockCountrySelect",
    ],
    data() {
        return {
            orderData: null,
            user: {
                addresses: [],
                billing: {
                    require_invoice: true,
                    data: {
                        type: "private",
                        name: "",
                        fiscal_code: "",
                        sdi: "",
                        pec: "",
                        address: "",
                        city: "",
                        cap: "",
                        province: "",
                        country: "IT",
                    },
                },
            },
            provinceFocusAddress: false,
            provinceFocusBilling: false,
            hide_save_billing_info: true,
            save_billing_info: false,
            save_new_address: false,
            hide_save_address: true,
            new_user: {
                name: "",
                email: "",
                password: "",
                confirm_password: "",
                create_account: false,
            },
            hasGift: false,
            stripeObject: null,
            paymentRequest: null,
            loading: false,
            pay: {
                method: "stripe",
            },
            discount_placeholder: true,
            giftPack: {
                status: true,
                message: "",
            },
            address: {
                name: "",
                address: "",
                city: "",
                cap: "",
                province: "",
                country: "IT",
            },
            billing: {
                type: "private", //normally is private, here we forced company
                name: "",
                fiscal_code: "",
                sdi: "",
                pec: "",
                address: "",
                city: "",
                cap: "",
                province: "",
                country: "IT",
            },
            discountCode: "",
            cart: null,
            shipping: 0,
            discount: 0,
            count: 0,
            showDiscountBox: false,
            missing_for_free_shipping: 0,
            validation: {
                new_user: {
                    name: {
                        state: null,
                        message: "",
                    },
                    email: {
                        state: null,
                        message: "",
                    },
                    phone: {
                        state: null,
                        message: "",
                    },
                    password: {
                        state: null,
                        message: "",
                    },
                    password_confirmation: {
                        state: null,
                        message: "",
                    },
                    privacy: {
                        state: null,
                        message: "",
                    },
                },
                address: {
                    name: {
                        state: null,
                        message: "",
                    },
                    phone: {
                        state: null,
                        message: "",
                    },
                    address: {
                        state: null,
                        message: "",
                    },
                    email: {
                        state: null,
                        message: "",
                    },
                    city: {
                        state: null,
                        message: "",
                    },
                    cap: {
                        state: null,
                        message: "",
                    },
                    province: {
                        state: null,
                        message: "",
                    },
                    country: {
                        state: null,
                        message: "",
                    },
                    privacy: {
                        state: null,
                        message: "",
                    },
                },
                billing: {
                    name: {
                        state: null,
                        message: "",
                    },
                    fiscal_code: {
                        state: null,
                        message: "",
                    },
                    sdi: {
                        state: null,
                        message: "",
                    },
                    pec: {
                        state: null,
                        message: "",
                    },
                    address: {
                        state: null,
                        message: "",
                    },
                    city: {
                        state: null,
                        message: "",
                    },
                    cap: {
                        state: null,
                        message: "",
                    },
                    province: {
                        state: null,
                        message: "",
                    },
                },
                discount: {
                    state: null,
                    message: "",
                },
            },
            btn_disabled: false,
            profile_loaded: false,
            billing_memo: null,
            should_be_shipped: false,
        };
    },
    watch: {
        "orderData.data.ship.privacy": {
            handler: function (n, o) {
                if (n) {
                    this.validation.address.privacy.state = null;
                }
            },
            deep: true,
        },
    },
    created() {
        this.orderData = _.cloneDeep(this.order);
        this.orderData.data.ship.country = "IT";
        this.orderData.should_be_shipped = true;

        if (
            typeof this.orderData.data.ship == "undefined" ||
            this.orderData.data.ship == null
        ) {
            this.orderData.data.ship = {
                name: "",
                address: "",
                email: "",
                city: "",
                cap: "",
                province: "",
                country: "",
                privacy: false,
                invoice: false,
            };
        }

        if (
            typeof this.orderData.data.billing == "undefined" ||
            this.orderData.data.billing == null
        ) {
            this.orderData.data.billing = {
                type: "private",
                name: "",
                fiscal_code: "",
                sdi: "",
                pec: "",
                address: "",
                city: "",
                cap: "",
                province: "",
            };
        }

        if (
            typeof this.orderData.data.giftPack == "undefined" &&
            this.orderData.data.giftPack == null
        ) {
            this.giftPack.status = true;
            this.giftPack.message = this.orderData.data.giftPack;
        }
    },
    mounted() {
        if (!this.shouldBeShipped) {
            this.hide_save_address = true;
        }

        this.new_user.name = this.orderData.data.ship.name;
        this.new_user.email = this.orderData.data.ship.email;

        if ($(".side-panel").length) {
            var top = $(".side-panel").offset().top;
            var width = 0;
            var left = $(".side-panel").offset().left;
            var bounds = document
                .querySelector(".side-panel")
                .getBoundingClientRect();

            function setSideMenu() {
                if ($(window).width() <= 991) {
                    return false;
                }

                if ($(window).scrollTop() < top - 48) {
                    $(".side-panel").removeClass("position-fixed");
                    $(".side-panel").css("top", "");
                    $(".side-panel").css("width", "");
                    $(".side-panel").css("left", "");
                } else {
                    $(".side-panel").addClass("position-fixed");

                    var ch = $(".side-panel").height();

                    var fp = $(".checkout-container-row-4")
                        .get(0)
                        .getBoundingClientRect().top;

                    if (fp < ch + 20) {
                        var ofst = -(ch - fp);

                        $(".side-panel").css("top", ofst);
                    } else {
                        $(".side-panel").css("top", 20);
                    }

                    $(".side-panel").css("width", width);
                    $(".side-panel").css("left", left);
                }
            }

            setTimeout(() => {
                if ($(".side-panel").length && $(window).width() >= 992) {
                    top = $(".side-panel").offset().top;
                    width = $(".side-panel").outerWidth();

                    if ($(".side-panel").length) {
                        setSideMenu();
                    }

                    $(window).on("scroll", function () {
                        if ($(".side-panel").length) {
                            setSideMenu();
                        }
                    });

                    $(window).on("resize", function () {
                        window.scrollTo(0, 0);
                        $(".side-panel").removeClass("position-fixed");
                        $(".side-panel").css("top", "");
                        $(".side-panel").css("width", "");
                        $(".side-panel").css("left", "");

                        if ($(window).width() >= 991) {
                            top = $(".side-panel").offset().top;
                            width = $(".side-panel").outerWidth();

                            if ($(".side-panel").length) {
                                setSideMenu();
                            }
                        } else {
                            $(".side-panel").removeClass("position-fixed");
                            $(".side-panel").css("top", "");
                            $(".side-panel").css("width", "");
                            $(".side-panel").css("left", "");
                        }
                    });
                }
            }, 500);
        }
        this.loadStripe();
    },
    methods: {
        summonPopup() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
            setTimeout(() => {
                this.$eventHub.$emit("login", { hide_register: true });
            }, 400);
        },
        manageSaveAddressCheckbox() {
            if (this.address.new) {
                this.hide_save_address = false;
            } else {
                this.hide_save_address = true;
                this.save_new_address = false;
            }
        },
        toggleLogin() {
            this.$eventHub.$emit("login", {});
        },
        getValueFromAttributes(string, key, value) {
            let json = JSON.parse(string);
            let found = "";

            if (key == "visit") {
                Object.keys(json.visit).forEach((elem2, index) => {
                    if (elem2 == value) {
                        found = json.visit[elem2];
                    }
                });
            } else {
                Object.keys(json.attributes).forEach((elem2, index) => {
                    if (json.attributes[elem2] != null) {
                        Object.keys(json.attributes[elem2]).forEach(
                            (elem3, index2) => {
                                if (json.attributes[elem2][elem3] == key) {
                                    if (
                                        typeof json.attributes[elem2][value] !=
                                        "undefined"
                                    ) {
                                        //console.log(json.attributes[elem2][value]);
                                        found = json.attributes[elem2][value];
                                    }
                                }
                            }
                        );
                    }
                });
            }

            return found;
        },
        loadStripe() {
            axios.get("/api/cart/stripe").then((response) => {
                this.stripeObject = Stripe(response.data.pkey);
                // let paymentRequest = this.stripeObject.paymentRequest({
                //     country: "IT",
                //     currency: "eur",
                //     total: {
                //         label: "Ordine Shop Cantina Letrari",
                //         amount: parseInt(
                //             parseFloat(this.order.final_price) * 100
                //         ),
                //     },
                //     requestPayerName: true,
                //     requestPayerEmail: true,
                // });

                // // Check the availability of the Payment Request API first.
                // paymentRequest
                //     .canMakePayment()
                //     .then((result) => {
                //         if (
                //             result &&
                //             (result.applePay == true ||
                //                 result.googlePay == true)
                //         ) {
                //             this.paymentRequest = paymentRequest;
                //         } else {
                //             this.paymentRequest = null;
                //         }
                //     })
                //     .catch((e) => {});
                this.paymentRequest = null;
            });
        },
        updateOrderAndPay() {
            this.btn_disabled = true;
            if (this.canProceed()) {
                this.loading = true;
                axios
                    .post("/api/cart/update-order", {
                        lang: this.lang,
                        order_id: this.orderData.id,
                        token: this.orderData.token,
                        pay: this.orderData.payment_method,
                        address: this.orderData.data.ship,
                        billing: this.orderData.data.billing,
                        giftPack: this.giftPack,
                        require_invoice: this.user.billing.require_invoice,
                        new_user: this.new_user,
                        save_new_address: this.save_new_address,
                        save_billing_info: this.save_billing_info,
                    })
                    .then((response) => {
                        if (response.data.action == "stripe_js") {
                            //var stripe = Stripe(response.data.pkey);
                            this.stripeObject
                                .redirectToCheckout({
                                    sessionId: response.data.payment_intent,
                                })
                                .then(function (result) {
                                    this.btn_disabled = false;
                                });
                        } else if (response.data.action == "stripe_apple_pay") {
                            var stripe = this.stripeObject;
                            var clientSecret = response.data.client_secret;
                            var confirm_page = response.data.confirm_page;

                            this.paymentRequest.on(
                                "paymentmethod",
                                async (ev) => {
                                    const {
                                        paymentIntent,
                                        error: confirmError,
                                    } = await stripe.confirmCardPayment(
                                        null,
                                        {
                                            payment_method: ev.paymentMethod.id,
                                        },
                                        { handleActions: false }
                                    );

                                    if (confirmError) {
                                        ev.complete("fail");
                                    } else {
                                        ev.complete("success");
                                        if (
                                            paymentIntent.status ===
                                            "requires_action"
                                        ) {
                                            // Let Stripe.js handle the rest of the payment flow.
                                            const { error } =
                                                await stripe.confirmCardPayment(
                                                    clientSecret
                                                );
                                            if (error) {
                                                // The payment failed -- ask your customer for a new payment method.
                                            } else {
                                                window.location.href =
                                                    confirm_page;
                                            }
                                        } else {
                                            window.location.href = confirm_page;
                                        }
                                    }
                                }
                            );
                            console.log(this.paymentRequest);
                        } else if (response.data.action == "redirect") {
                            window.location.href = response.data.next_action;
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        return;
                        if (typeof e.response.data.location != "undefined") {
                            window.location.href = e.response.data.location;
                        } else {
                            location.reload(true);
                        }
                    });
            }
        },
        isNotEmpty(object) {
            return _.isEmpty(object) === false;
        },
        canProceed() {
            let is_invalid = false;

            if (!this.isLogged) {
                Object.keys(this.validation.new_user).forEach((elem, key) => {
                    this.validation.new_user[elem].message = "";
                    this.validation.new_user[elem].state = null;
                });

                let is_new =
                    typeof this.order.user_id == "undefined" ||
                    this.order.user_id == null;

                if (this.new_user.name == "" && is_new) {
                    if (this.lang == "it") {
                        this.validation.new_user.name.message =
                            "Questo campo non può essere vuoto.";
                    } else {
                        this.validation.new_user.name.message =
                            "This field cannot be empty.";
                    }
                    this.validation.new_user.name.state = false;
                    is_invalid = true;
                } else {
                    this.validation.new_user.name.state = null;
                }

                let re =
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let disposable = require("is-disposable-email");
                if (!re.test(this.new_user.email)) {
                    if (this.lang == "it") {
                        this.validation.new_user.email.message =
                            "Non sembra un indirizzo email valido.";
                    } else {
                        this.validation.new_user.email.message =
                            "The email address is invalid.";
                    }
                    this.validation.new_user.email.state = false;
                    is_invalid = true;
                } else {
                    if (disposable(this.new_user.email)) {
                        if (this.lang == "it") {
                            this.validation.new_user.email.message =
                                "Tipologia di servizio email non valido.";
                        } else {
                            this.validation.new_user.email.message =
                                "You email provider is invalid.";
                        }
                        this.validation.new_user.email.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.email.state = null;
                    }
                }

                if (this.new_user.create_account && is_new) {
                    if (this.new_user.password == "") {
                        if (this.lang == "it") {
                            this.validation.new_user.password.message =
                                "Questo campo non può essere vuoto.";
                        } else {
                            this.validation.new_user.password.message =
                                "This field cannot be empty.";
                        }
                        this.validation.new_user.password.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.password.state = null;
                    }

                    if (
                        this.new_user.password_confirmation !=
                            this.new_user.password ||
                        this.user.password_confirmation == ""
                    ) {
                        if (this.lang == "it") {
                            this.validation.new_user.password_confirmation.message =
                                "Questo campo deve coincidere con la password.";
                        } else {
                            this.validation.new_user.password_confirmation.message =
                                "Questo campo non può essere vuoto.";
                        }
                        this.validation.new_user.password_confirmation.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.password_confirmation.state =
                            null;
                    }
                }

                if (!this.new_user.privacy && is_new) {
                    if (this.lang == "it") {
                        this.validation.new_user.privacy.message =
                            "È necessario accettare i termini.";
                    } else {
                        this.validation.new_user.privacy.message =
                            "You need to accept the terms.";
                    }
                    this.validation.new_user.privacy.state = false;
                    is_invalid = true;
                }
            }

            Object.keys(this.validation.address).forEach((elem, key) => {
                this.validation.address[elem].message = "";
                this.validation.address[elem].state = null;
            });

            Object.keys(this.validation.billing).forEach((elem, key) => {
                this.validation.billing[elem].message = "";
                this.validation.billing[elem].state = null;
            });

            if (this.shouldBeShipped) {
                $.each(this.orderData.data.ship, (key, elem) => {
                    if (typeof this.validation.address[key] != "undefined") {
                        if (elem == "") {
                            if (this.lang == "it") {
                                this.validation.address[key].message =
                                    "Il campo è obbligatorio";
                            } else {
                                this.validation.address[key].message =
                                    "This field is required";
                            }

                            this.validation.address[key].state = false;
                            is_invalid = true;
                        }
                    }
                });
            }

            /*if(!this.orderData.data.ship.privacy) {
                if(this.lang == 'it') {
                    this.validation.address.privacy.message = 'È necessario accettare i termini per proseguire';
                }else{
                    this.validation.address.privacy.message = 'You need to accept the terms to proceed';
                }
                this.validation.address.privacy.state = false;
                is_invalid = true;
            }*/

            if (this.orderData.data.ship.invoice) {
                if (this.orderData.data.billing.type == "company") {
                    $.each(this.orderData.data.billing, (key, elem) => {
                        if (elem == "" && key != "sdi" && key != "pec") {
                            if (this.lang == "it") {
                                this.validation.billing[key].message =
                                    "Il campo è obbligatorio";
                            } else {
                                this.validation.billing[key].message =
                                    "This field is required";
                            }
                            this.validation.billing[key].state = false;
                            is_invalid = true;
                        }
                    });

                    if (
                        this.orderData.data.billing.sdi == "" &&
                        this.orderData.data.billing.pec == ""
                    ) {
                        if (this.lang == "it") {
                            this.validation.billing.pec.message =
                                "Compila PEC o Codice univoco";
                            this.validation.billing.sdi.message =
                                "Compila PEC o Codice univoco";
                        } else {
                            this.validation.billing.pec.message =
                                "Either one between PEC or SDI is required";
                            this.validation.billing.sdi.message =
                                "Either one between PEC or SDI is required";
                        }
                        this.validation.billing.pec.state = false;
                        this.validation.billing.sdi.state = false;

                        is_invalid = true;
                    }
                } else {
                    if (this.orderData.data.billing.fiscal_code == "") {
                        if (this.lang == "it") {
                            this.validation.billing.fiscal_code.message =
                                "Il campo è obbligatorio";
                        } else {
                            this.validation.billing.fiscal_code.message =
                                "This field is required";
                        }
                        this.validation.billing.fiscal_code.state = false;
                        is_invalid = true;
                    } else {
                        if (this.getAge() != null && this.getAge() < 18) {
                            if (this.lang == "it") {
                                this.validation.billing.fiscal_code.message =
                                    "Devi essere maggiorenne per completare l'acquisto";
                            } else {
                                this.validation.billing.fiscal_code.message =
                                    "You must be over 18 years of age to buy our products";
                            }
                            this.validation.billing.fiscal_code.state = false;
                            is_invalid = true;
                        }
                    }
                }
            }

            if (is_invalid) {
                setTimeout(() => {
                    this.btn_disabled = false;

                    let elements =
                        document.querySelectorAll(".invalid-feedback");

                    window.scroll({
                        top:
                            parseInt(
                                elements[0].getBoundingClientRect().top +
                                    window.scrollY
                            ) - 150,
                        behavior: "smooth",
                    });
                }, 500);

                return false;
            }

            return true;
        },

        getAge() {
            const monthsRepo = {
                A: "01",
                B: "02",
                C: "03",
                D: "04",
                E: "05",
                H: "06",
                L: "07",
                M: "08",
                P: "09",
                R: "10",
                S: "11",
                T: "12",
            };

            return this.billing.fiscal_code.replace(
                /^(?:\w{6})(\d{2})(\w)(\d{2}).+$/,
                function (data, aa, mm, gg) {
                    let year = parseInt(aa, 10);
                    let century = year < 9 ? "20" : "19";
                    year = [century, aa].join("");

                    let day = parseInt(gg, 10);
                    let sex = day > 31 ? "F" : "M";
                    if (sex === "F") day -= 40;

                    let month = mm.toUpperCase();
                    month = monthsRepo[month];

                    let date = [day, month, year].join("/");

                    let result = null;

                    try {
                        result = moment(date, "DD/MM/YYYY")
                            .fromNow(true)
                            .replace(" years", "");
                    } catch (e) {
                        result = null;
                    }

                    return result;
                }
            );
        },
    },
    computed: {
        shouldBeShipped() {
            return this.orderData.should_be_shipped;
        },
        managePaymentMethodsCardinal() {
            if (!this.isLogged) {
                return this.orderData.data.ship.invoice == false
                    ? "03. "
                    : "04. ";
            } else {
                return this.orderData.data.ship.invoice == false
                    ? "02. "
                    : "03. ";
            }
        },
        price() {
            let p = 0;

            if (this.cart != null) {
                for (let [key, item] of Object.entries(this.cart)) {
                    if (this.isNotEmpty(item)) {
                        if (typeof item.subtotal != "undefined") {
                            p += parseFloat(item.subtotal);
                        } else {
                            p += parseFloat(item.price) * parseFloat(item.qty);
                        }
                    }
                }
            }

            return p + this.shipping;
        },
    },
};
</script>

<style lang="scss">
/*
.v-select {

    .vs__dropdown-toggle{
        padding: 0 !important;
        background: none !important;
        border: 0 !important;
    }

    .vs__selected-options{
        padding:0px !important;
    }

    .vs__actions{
        display: none !important;
    }

    .vs__dropdown-menu{
        top: 41px !important;
        border: 0;
        box-shadow: none;
        background: #f1ece5;

        &::-webkit-scrollbar {
            width: 4px;
        }

    }

    .vs__search, .vs__search:focus{
        background: transparent;
        border: 0;
        border-bottom: 1px solid #c9c8c0;
        outline: none !important;
        color: #b4b3aa;
        padding: 7px 2px;
        font-size: 1rem;
        width: 100%;
        font-family: "europa", sans-serif;
        margin: 4px;
        margin-left: 0px;
        margin-right: 0px;
    }

    .not-found{
        color:#776c5d !important;
        font-size: .9rem !important;
    }

    .vs__dropdown-option{
        padding: 6px 20px;
        color: #a09688;
        background: none;

        &:hover{
            color:#776c5d;
        }

    }

    & ~ label.placeholder{
        position: absolute;
        left: 0rem;
        width: 100%;
        font-size: 1rem;
        color: #b4b3aa;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        margin: 0;
        padding: 7px 2px;
        transition: all .1s;
        z-index: 10;
        text-align: left;
        pointer-events:none;
    }

    &.vs--open, &.full{

        & ~ label.placeholder{
            transform: translate(0px, -22px);
            font-size: 73%;
        }

    }

    .vs__selected{
        margin: 0;
        padding: 0 .15em;
        position: absolute;
        left: 0;
        top: 9px;
        color:#b4b3aa;
    }

}*/
</style>
